module.exports = __webpack_public_path__ + "static/successed-c6459553352f2b2cc0e8b28ac4761cbe.svg";